import React from 'react';
import { FCFormPageType } from 'new/elements/Form/useForm';
import { EnterCredential } from 'new/elements/flows/EnterCredential';
import { useAuthenticateStep } from 'new/components/flows/types/DirectFlow/hooks/useAuthenticateStep';
import { useDirectFlow } from 'new/components/flows/types/DirectFlow/hooks/useDirectFlow';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_ALL_CREDENTIALS_REQUEST, GET_FULL_VENDOR_REQUEST } from 'js/constants/actionTypes';

export const AuthenticateStep: FCFormPageType<{}> = () => {
  const {
    credentialId,
    selectedConnection,
    onChangeTemplate,
    selectedTemplate,
    onSaveCredential,
    onEditCredential,
    reloadCredentials,
    onCredentialSelected,
    onCredentialInfoUpdated,
  } = useAuthenticateStep();
  const { selectedCredentialInfo } = useDirectFlow() as any;
  const areCredentialsLoading = useIsLoading(GET_ALL_CREDENTIALS_REQUEST, GET_FULL_VENDOR_REQUEST);

  return (
    <EnterCredential
      reload={reloadCredentials}
      areCredentialsLoading={areCredentialsLoading}
      credentialId={credentialId}
      onChangeTemplate={onChangeTemplate}
      selectedTemplate={selectedTemplate}
      connectionType={selectedConnection}
      selectedCredentialInfo={selectedCredentialInfo}
      onSaveCredential={onSaveCredential}
      onEditCredential={onEditCredential}
      onCredentialSelected={onCredentialSelected}
      onCredentialInfoUpdated={onCredentialInfoUpdated}
    />
  );
};

AuthenticateStep.formConfig = {
  title: 'Authenticate',
};
